import React from 'react'
import { apiFetch } from './fetchApi'

export const fetchUpdateJob = (BeURL, id,  showAlert, setUpdateJobList) => {
   apiFetch(`${BeURL}/fetch-job/${id}`,{
    method : 'GET',
   })
   .then(res=>res.json())
   .then(data => {
    if(data.success){
         setUpdateJobList(data.job)
    }
    else{
        showAlert(data.message)
    }
   })
   .catch(err=>{
    console.log("Error in fetch update job list",err)
   })
}
